import(/* webpackMode: "eager" */ "/propertyspace/components/BlogCardSlider.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/DistrictCardSlider.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/FacebookTimeline.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/Hero.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/HomeMap.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/NewDevelopmentCardSlider.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/PropertyCardSlider.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/ServiceCards.js");
import(/* webpackMode: "eager" */ "/propertyspace/components/TestamonialCard.js")